import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import animationClasses from './appear.anim.scss';
import classes from './product-favourite-button.scss';
const timeout = {
  enter: 1100,
  appear: 100,
  exit: 300
};
export function ProductFavouriteButton({
  className = undefined,
  onClick,
  isFavourite,
  isFavouritesPage = false,
  disableChangingState = false,
  tabIndex = 0
}) {
  const isSelectedDefaultValue = isFavouritesPage ? true : isFavourite;
  const [isSelected, changeFavourite] = useState(isSelectedDefaultValue);
  useEffect(() => {
    changeFavourite(isFavourite);
  }, [isFavourite]);
  const handleClick = () => {
    const nextValue = !isSelected;
    if (!disableChangingState) {
      changeFavourite(nextValue);
    }
    onClick(nextValue);
  };
  return /*#__PURE__*/React.createElement("div", {
    onClick: handleClick,
    className: classnames(classes.favorite, className),
    onKeyDown: e => handleOnEnterPressed(e, handleClick),
    tabIndex: tabIndex
  }, isFavouritesPage ? /*#__PURE__*/React.createElement("div", {
    className: classes.removeFavouriteIcon
  }) : /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: animationClasses,
    key: isSelected ? 'favourite' : 'not-favourite',
    timeout: timeout
  }, isSelected ? /*#__PURE__*/React.createElement(FavoriteIcon, null) : /*#__PURE__*/React.createElement(FavoriteBorderIcon, {
    className: classes.alwaysBlack
  }))));
}